import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var ClearSelections = function ClearSelections(_ref) {
  var onClick = _ref.onClick,
    allOptionsSelected = _ref.allOptionsSelected;
  var clearAllClass = function clearAllClass() {
    return classNames({
      'px-2.5 py-0 pb-1 text-right block': true,
      'border-b border-light-border-blue border-solid': !allOptionsSelected
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: clearAllClass()
  }, /*#__PURE__*/React.createElement("a", {
    role: "button",
    onClick: onClick,
    tabIndex: 0
  }, "Clear All"));
};
ClearSelections.propTypes = {
  allOptionsSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};
export default ClearSelections;